import type {
  DividerData_Alignment,
  DividerData_LineStyle,
  DividerData_Width,
  Node_Type,
  RichContent,
  TextStyle_TextAlignment,
} from 'ricos-schema';

const oneNodeWithText: RichContent = {
  nodes: [
    {
      type: 'PARAGRAPH' as Node_Type,
      id: 'm1np0803',
      nodes: [
        {
          type: 'TEXT' as Node_Type,
          id: '',
          nodes: [],
          textData: {
            text: 'blabla',
            decorations: [],
          },
        },
      ],
      paragraphData: {
        textStyle: {
          textAlignment: 'AUTO' as TextStyle_TextAlignment,
        },
      },
    },
  ],
  metadata: {
    version: 1,
    id: '0a67745a-71da-4153-afcc-576aeca2ab17',
  },
  documentStyle: {},
};

const oneNodeWithEmptyHeading: RichContent = {
  nodes: [
    {
      type: 'HEADING' as Node_Type,
      id: 'm1np0803',
      nodes: [],
      headingData: {
        level: 1,
        textStyle: {
          textAlignment: 'AUTO' as TextStyle_TextAlignment,
        },
        indentation: 0,
      },
    },
  ],
  metadata: {
    version: 1,
    id: '0a67745a-71da-4153-afcc-576aeca2ab17',
  },
  documentStyle: {},
};

const oneNodeWithIndentAndEmptyText: RichContent = {
  nodes: [
    {
      type: 'PARAGRAPH' as Node_Type,
      id: 'm1np0803',
      nodes: [],
      paragraphData: {
        textStyle: {
          textAlignment: 'AUTO' as TextStyle_TextAlignment,
        },
        indentation: 1,
      },
    },
  ],
  metadata: {
    version: 1,
    id: '0a67745a-71da-4153-afcc-576aeca2ab17',
  },
  documentStyle: {},
};

const dividerOnly: RichContent = {
  nodes: [
    {
      type: 'DIVIDER' as Node_Type,
      id: '9qis8468',
      nodes: [],
      dividerData: {
        lineStyle: 'SINGLE' as DividerData_LineStyle,
        width: 'LARGE' as DividerData_Width,
        alignment: 'CENTER' as DividerData_Alignment,
      },
    },
    {
      type: 'PARAGRAPH' as Node_Type,
      id: 'smr8r500',
      nodes: [],
      paragraphData: {},
    },
  ],
  metadata: {
    version: 1,
    id: '0a67745a-71da-4153-afcc-576aeca2ab17',
  },
  documentStyle: {},
};

export const NonEmptyRichContentState = {
  oneNodeWithText,
  oneNodeWithEmptyHeading,
  oneNodeWithIndentAndEmptyText,
  dividerOnly,
};
